export default "__VITE_ASSET__5bc3f389__"